import {Component} from '@angular/core';
import {PatronSelectors} from '@store/store.selectors';

@Component({
  selector: 'rn-create-account',
  templateUrl: './create-account.component.html',
  styleUrl: './create-account.component.scss',
  standalone: false
})
export class CreateAccountComponent {
  public readonly patronSelectors = PatronSelectors.Registration;
}
